import {
  USER_CW_LOGIN_ENDPOINT,
  USER_CW_SINGNUP_ENDPOINT,
  USER_CW_CHECKLOGIN_ENDPOINT,
  USER_CW_SOCIAL_SINGNUP_ENDPOINT,
  USER_CW_LOGOUT_ENDPOINT,
  USER_PASSWORD_RESET_ENDPOINT,
  SUCCESS_STATUS_CODES,
} from "../constants";

import ApiCall from "GlobalUtils/ApiCalls";
import { getHeaders } from "../utils";

const cwLogin = ({
  email,
  password,
  reCaptchaResponse,
  platForm,
  rememberMe,
}) => {
  const loginInputs = {
    email,
    password,
    rememberMe,
  };
  return ApiCall.fetchApi({
    url: USER_CW_LOGIN_ENDPOINT,
    requestInit: {
      method: "POST",
      headers: getHeaders(reCaptchaResponse, platForm),
      body: JSON.stringify(loginInputs),
    },
    successStatusCodes: SUCCESS_STATUS_CODES,
  });
};

const cwSignup = ({
  name,
  email,
  password,
  mobile,
  reCaptchaResponse,
  platForm,
}) => {
  const signUpInputs = {
    name,
    email,
    pass: password,
    confpass: password,
    mobile,
  };
  return ApiCall.fetchApi({
    url: USER_CW_SINGNUP_ENDPOINT,
    requestInit: {
      method: "POST",
      headers: getHeaders(reCaptchaResponse, platForm),
      body: JSON.stringify(signUpInputs),
    },
    successStatusCodes: SUCCESS_STATUS_CODES,
  });
};

const socialMediaSignIn = request => {
  const options = {
    accesstoken: request.AccessToken,
    email: request.Email,
    socialplatform: request.SocialPlatform,
    fbid: request.FbId,
  };
  return ApiCall.fetchApi({
    url: USER_CW_SOCIAL_SINGNUP_ENDPOINT,
    options: options,
    requestInit: {
      method: "GET",
      headers: getHeaders("", request.platForm),
    },
    successStatusCodes: [200, 400],
  });
};

const cwCheckSingnedIn = () => {
  return ApiCall.fetchApi({ url: USER_CW_CHECKLOGIN_ENDPOINT });
};

const cwLogout = () => {
  return ApiCall.fetchApi({
    url: USER_CW_LOGOUT_ENDPOINT,
    responseType: "none",
  });
};

const cwResetPassword = ({ emailId, reCaptchaResponse, platForm }) => {
  return ApiCall.fetchApi({
    url: USER_PASSWORD_RESET_ENDPOINT,
    options: { emailId },
    requestInit: {
      method: "POST",
      headers: getHeaders(reCaptchaResponse, platForm),
    },
    successStatusCodes: SUCCESS_STATUS_CODES,
  });
};

const CarwaleLoginApi = {
  cwLogin,
  cwLogout,
  cwSignup,
  cwCheckSingnedIn,
  socialMediaSignIn,
  cwResetPassword,
};

export default CarwaleLoginApi;
